<template>
  <div class="mail" ref="el" data-split-context>
    <div class="mail__top sp-60">
      <AppLink @click="handleClose" class="fs-12 tt-u ff-mono">
        X Close
      </AppLink>

      <div class="d-f ai-c">
        <div class="mail__timer__indicator"></div>
        <span class="mail__timer fs-14 ff-mono">{{
          countdown.toString().padStart(2, '0')
        }}</span>
      </div>
    </div>

    <p class="fs-48" data-split>
      {{ globals?.mail_confirm_message_title }}
    </p>
    <div class="mail__footer">
      <span>
        {{ globals?.mail_confirm_message_subtitle }}
        <a :href="`mailto:${globals?.email}`">
          <AppLink :underline="true">{{ globals.email }}</AppLink>
        </a>
      </span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({});

const el = ref(null);
const globals = useGlobal();
const isMenuOpen = useMenuOpen();
const { $eventBus } = useNuxtApp();
// const isAboutModalVisible = useAboutModal();
const { animateOut, initSplitText, countdown } = useMailConfirm(el);

const handleClose = () => {
  animateOut();
};

const handleEscape = e => {
  if (e.key === 'Escape') {
    handleClose();
  }
};

onMounted(() => {
  initSplitText();
  if (isMenuOpen.value) {
    $eventBus.emit('closeMenu');
  }
  window.addEventListener('keydown', handleEscape);
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleEscape);
});
</script>

<style lang="scss" scoped>
.mail {
  background: var(--c-bg-alt);
  bottom: var(--gutter);
  color: var(--c-text-alt);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 40vh;
  padding: var(--offset);
  position: fixed;
  right: var(--offset);
  transform: translateY(calc(100% + var(--offset)));
  width: var(--col-4);
  z-index: layer(mailconfirm);
  border-radius: var(--radius);
  transition:
    bottom 0.5s ease(outExpo),
    right 0.5s ease(outExpo);

  @include mq(desktop) {
    right: var(--gutter);
    width: calc(var(--col-2) + (var(--col-1) / 2) + var(--offset));
  }

  &:deep(.line) {
    // white-space: pre-line;
    transform: translateY(100%);
    transition: transform 1.25s ease(outExpo)
      calc((var(--index) * 0.1s) + 0.05s);
  }

  &.is-animated:deep(.line) {
    transform: translateY(0%);
  }

  p {
    width: 90%;
  }
}

.mail__footer {
  display: flex;
  justify-content: space-between;
}

.mail__timer {
  color: var(--c-text-mid);
  width: 2ch;
}

.mail__timer__indicator {
  animation: blink 0.5s linear infinite;
  background: #fff;
  display: flex;
  height: 1ch;
  margin-right: 1ch;
  width: 0.8ch;
}

.mail__top {
  display: flex;
  justify-content: space-between;
}

.mail__footer {
  margin-top: auto;
}
</style>
